module.exports = __webpack_public_path__ + "static/img/006.bc09a76d.png";